export default __webpack_public_path__ + "static/Nomba-a318a9a38078fd8334d9cc54e2025893.gif";